import { Box, Collapse } from '@mui/material';
import React, { useContext } from 'react'
import AudioSound from '../AudioPlayer/AudioSound';
import SettingsSpeedDial from '../SettingsLombard/SettingSpeedDial';
import CreditsUi from '../CreditsUi/CreditsUi';
import FreeCreditsUi from '../CreditsUi/FreeCreditsUi';
import ThoughtItemCommon from '../ThoughtItem/ThoughtItemCommon';
// import { CharacterBubbleRef } from '../CharacterViewer/CharacterBubble';
import { CharacterBubble2Ref } from '../CharacterViewer/CharacterBubble2';
import { WidgetContext } from 'src/contexts/WidgetContext';
import AccountSpeedDial from '../SettingsLombard/AccountSpeedDial';
import QuanAccountSpeedDial from '../SettingsLombard/QuanAccountSpeedDial';
import QuanSettingsSpeedDial from '../SettingsLombard/QuanSettingsSpeedDial';

interface SettingsHomePageProps {
    shouldPlayAudio: boolean;
    authId: string;
    setIsSliderOpen: (isOpen: boolean) => void;
    // characterRef: React.RefObject<CharacterBubbleRef>;
    characterRef: React.RefObject<CharacterBubble2Ref>;
    thoughtsCommon: string;
    isDrawerOpen: boolean;
    isSliderOpen: boolean;
    isMobile: boolean;
    isChangingPlatform: boolean;
    handlePartnerSelectAndCloseDrawer: () => void;
    isAiDialogOpen: boolean;
    setIsAiDialogOpen: (isOpen: boolean) => void;
    handleConfirmAiSettings: (nextSettings: Record<string, boolean>) => void | Promise<void>;
    aiSettings: any;
    isUpdatingAiSettings: boolean;
    isPaymentOpen: boolean;
    setIsPaymentOpen: (isOpen: boolean) => void;
    setInitialPaymentView: (initialPaymentView: string) => void;
    initialPaymentView: string;
    enableCreditValidation: boolean;
    userSubscription: string;
    isCreditsAnimating: boolean;
    creditsBoxRef: React.RefObject<HTMLDivElement>;
}

const SettingsHomePage = ({ shouldPlayAudio, authId, setIsSliderOpen, characterRef, thoughtsCommon, isDrawerOpen, isSliderOpen, isMobile, isChangingPlatform, handlePartnerSelectAndCloseDrawer, isAiDialogOpen, setIsAiDialogOpen, handleConfirmAiSettings, aiSettings, isUpdatingAiSettings, isPaymentOpen, setIsPaymentOpen, setInitialPaymentView, initialPaymentView, userSubscription, enableCreditValidation, isCreditsAnimating, creditsBoxRef }: SettingsHomePageProps) => {
    const { isLoggedInAuth0ExperienceGlobal, credits, freeCredits, selectedTeamInfo } = useContext(WidgetContext);
    // show thoughts if there are thoughts and the drawer is not open/slider is not open/platform is not changing/selected team info is not null
    const showThoughts =
        !!thoughtsCommon &&
        !isDrawerOpen &&
        (!isSliderOpen || !isMobile) &&
        !isChangingPlatform &&
        !!selectedTeamInfo;


    return (
        <>
            <Box
                p={0}
                sx={{
                    position: "relative",
                    top: 0,
                    // pt: "env(safe-area-inset-top)", //safe area inset top
                    left: "env(safe-area-inset-left)", //safe area inset left
                    right: "env(safe-area-inset-right)", //safe area inset right
                    zIndex: 1301,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    paddingTop: "0px",
                    height: "56px",
                    // pb: !isLoggedInAuth0ExperienceGlobal ? 0.7 : 0,
                    flexShrink: 0, // Header fijo, no se encoge
                }}
            >
                {/* hidden audio sound until we have a way to play real audio */}
                {/* <Box sx={{ visibility: "hidden" }}>
   */}
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: 0.5 }}>
                    <AudioSound shouldPlayAudio={shouldPlayAudio} authId={authId} onSliderVisibilityChange={setIsSliderOpen} characterRef={characterRef} />
                    {/* Show credits UI if user is logged in and subscription is not free, otherwise show free credits UI */}
                    {isLoggedInAuth0ExperienceGlobal && userSubscription !== "free" ? (
                        <CreditsUi credits={credits} isCreditsAnimating={isCreditsAnimating} creditsBoxRef={creditsBoxRef} />
                    ) : (
                        <FreeCreditsUi freeCredits={freeCredits} isCreditsAnimating={isCreditsAnimating} creditsBoxRef={creditsBoxRef} />
                    )}

                    <SettingsSpeedDial
                        onClose={handlePartnerSelectAndCloseDrawer}
                        isAiDialogOpen={isAiDialogOpen}
                        onOpenAiSettings={() => setIsAiDialogOpen(true)}
                        onCloseAiSettings={() => setIsAiDialogOpen(false)}
                        onConfirmAiSettings={handleConfirmAiSettings}
                        aiSettings={aiSettings}
                        isUpdatingAiSettings={isUpdatingAiSettings}
                        isPaymentOpen={isPaymentOpen}
                        onPaymentOpenChange={(isOpen, view?: string) => {
                            if (isOpen) {
                                setInitialPaymentView(view || "menu");
                            }
                            setIsPaymentOpen(isOpen);
                        }}
                        initialPaymentView={initialPaymentView}
                        credits={credits}
                        enableCreditValidation={enableCreditValidation}

                    />

                </Box>
                {/* <TypingDots /> */}
                {/* Thoughts for common league data */}
                {/* <Fade in={thoughtsCommon && !isDrawerOpen && (!isSliderOpen || !isMobile)} timeout={1000}>
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            overflow: "hidden",
                            position: "relative",
                            zIndex: 1,
                            pt: 1
                        }}
                    >
                        {!!thoughtsCommon && !isDrawerOpen && (!isSliderOpen || !isMobile) && !isChangingPlatform && !!selectedTeamInfo && <ThoughtItemCommon text={thoughtsCommon} />} */}
                {/* <ThoughtItemCommon text={"Texto de prueba largo para ver el ancho"} /> */}
                {/* </Box>
                </Fade> */}



                {/* {isLoggedInAuth0ExperienceGlobal ? ( */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pr: 0.5,
                        flexShrink: 0,
                        position: "relative",
                        zIndex: 2,
                        gap: 0.5,
                    }}
                >


                    {isLoggedInAuth0ExperienceGlobal ?
                        <QuanAccountSpeedDial
                            onClose={handlePartnerSelectAndCloseDrawer}
                            isAiDialogOpen={isAiDialogOpen}
                            onOpenAiSettings={() => setIsAiDialogOpen(true)}
                            onCloseAiSettings={() => setIsAiDialogOpen(false)}
                            onConfirmAiSettings={handleConfirmAiSettings}
                            aiSettings={aiSettings}
                            isUpdatingAiSettings={isUpdatingAiSettings}
                            isPaymentOpen={isPaymentOpen}
                            onPaymentOpenChange={(isOpen, view?: string) => {
                                if (isOpen) {
                                    setInitialPaymentView(view || "menu");
                                }
                                setIsPaymentOpen(isOpen);
                            }}
                            initialPaymentView={initialPaymentView}
                            credits={credits}
                            enableCreditValidation={enableCreditValidation}
                            userSubscription={userSubscription}
                        /> :
                        <AccountSpeedDial />
                    }


                </Box>
                {/* )
        : (
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", pr: 1, color: `${PureLightThemeCaaS.colors.alpha.white[100]}`, }}>
        <HelpMenu />
        <FreeCreditsUi freeCredits={freeCredits} isCreditsAnimating={isCreditsAnimating} creditsBoxRef={creditsBoxRef} />
        </Box>
    )} */}
            </Box>
            {/* Thoughts for common league data */}
            <Collapse in={showThoughts} timeout={{ enter: 500, exit: 400 }} collapsedSize={0} unmountOnExit>
                <Box sx={{ pb: 1.5, pt: 0 }}>
                    <ThoughtItemCommon text={thoughtsCommon} />
                    {/* <ThoughtItemCommon text={"Texto de pruebaggg largo para ver el ancho"} />  */}
                </Box>
            </Collapse>
        </>
    )
}

export default SettingsHomePage